module.exports = __webpack_public_path__ + "media/images/bank_images/panamericano-dbdc13c5376fc8ad212824a899b92822.png";